// extracted by mini-css-extract-plugin
export default {"select":"SnjM7","selection":"bW_m_","wrapper":"nWOB7"};